var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TableRender',{attrs:{"Service":_vm.Service,"align":"center"}},[_c('TableText',{attrs:{"prop":"display_name","label":"职位","width":120}}),_c('TableAction',{attrs:{"buttons":[
    { name: '权限管理', onClick: _vm.handlePermissions },
    { name: '编辑' },
    { name: '删除' }
  ],"minWidth":250}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }